import "element-plus/theme-chalk/index.css";
import {
  ElAlert,
  ElAside,
  ElButton,
  ElCheckbox,
  ElForm,
  ElFormItem,
  ElInput,
  ElRadio,
  ElTabPane,
  ElTabs,
  ElLink,
  ElMenu,
  ElMenuItem,
  ElMenuItemGroup,
  ElCarousel,
  ElImage,
} from "element-plus";
import * as ElementPlusIconsVue from "@element-plus/icons-vue";

const components = [
  ElButton,
  ElTabs,
  ElTabPane,
  ElForm,
  ElFormItem,
  ElInput,
  ElRadio,
  ElAlert,
  ElAside,
  ElCheckbox,
  ElLink,
  ElMenu,
  ElMenuItem,
  ElMenuItemGroup,
  ElCarousel,
  ElImage
];
export default function (app) {
  for (const cpn of components) {
    app.component(cpn.name, cpn);
  }
  for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
    app.component(key, component);
  }
}
